import React from 'react';
import styled from 'styled-components';
import { Heading2, spacing } from '../../../theme';
import colors from '../../../theme/variables/colors';

const InfoElementHeader = styled(Heading2)`
    display: inline;
    margin-bottom: ${spacing.spacing2};
    align-items: center;
`;

const HeaderSection = styled.div`
    display: flex;
    border-bottom: 2px solid ${colors.palette.black};
    margin-bottom: ${spacing.spacing4};
`;

interface CardHeaderProps {
    title: string;
}

function CardHeader({ title }: CardHeaderProps) {
    return (
        <>
            <HeaderSection>
                <InfoElementHeader styledAs="h3" style={{maxWidth: '100%'}}>{title}</InfoElementHeader>
            </HeaderSection>
        </>
    );
}

export default CardHeader;
